var React = require('react');

function FooterShapeDesktop (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M217.765 -9.93176e-05C250.28 56.317 227.89 130.116 167.756 164.834C107.621 199.553 32.5147 182.044 0 125.727L217.765 -9.93176e-05Z","fill":"#44C877"}));
}

FooterShapeDesktop.defaultProps = {"width":"233","height":"183","viewBox":"0 0 233 183","fill":"none"};

module.exports = FooterShapeDesktop;

FooterShapeDesktop.default = FooterShapeDesktop;
